module.exports = {"link":"https://www.clinique.co.il/product/1599/52574/even-better-glowtm-makeup-spf-15--even-bettertm-light-reflecting-spf-15/even-better-glowtm-makeup-spf-15--even-bettertm-light-reflecting-spf-15?utm_source=EBG_Launch&utm_medium=content&utm_content=EBG_Content&utm_campaign=0218_EBG_dim","text":"<span class=\"head\">חדש! מייק אפ <span class=\"halva\">Even Better&trade; Glow</span></span> <span class=\"br\"><br/></span>של קליניק עכשיו במחיר השקה של &#8362;139 (במקום 159 &#8362;)!","button":{"text":"לחצי כאן"}}


//////////////////
// WEBPACK FOOTER
// ./src/api/FooterBanner.json
// module id = 10
// module chunks = 0